import styled from "styled-components";
import {DenmarkResponsibleGamingButtonBaseBox} from "../../boxes/denmark.responsible-gaming-button-base.box";

export const DenmarkSelfExclusionButtonBox = styled(DenmarkResponsibleGamingButtonBaseBox)`
    width: 50px;
    height: 25px;
`;
